import { Box, Flex, Image, Text } from "@chakra-ui/react";

const LoginHero = () => {
    return (
        <Flex
            display={{ base: "none", md: "flex" }}
            flexDirection="column"
            overflow="hidden"
            bg="#C33A4A"
            align="center"
            justify="center"
            w={{ base: "33%" }}
           position="relative"
        >

            {/* Text (di atas gambar) */}
            <Box
                position="relative"
                zIndex={1}
                textAlign="center"
                maxW="520px"
                mt={{ md: "-120px", lg: "-140px" }} // naikkan teks agar tidak ketabrak gambar
                color="white"
            >
                <Text fontSize={{ md: "2xl", lg: "3xl" }} fontWeight="bold" mb={3}>
                    Sistem Informasi Terpadu
                </Text>
                <Text fontSize="sm" opacity={0.9} lineHeight="tall">
                    Portal Data Datalake Management untuk mendukung transformasi digital
                    Indonesia yang aman, terpercaya, dan terintegrasi.
                </Text>
            </Box>

            {/* Gambar kanan bawah, ukurannya dibatasi supaya rapi */}
            <Image
                src="/images/login_image.png"
                alt="Login Illustration"
                right={{ md: "-20px", lg: "-10px" }}
                bottom={{ md: "-40px", lg: "-30px" }}
                w={{ md: "520px", lg: "640px" }}
                position="absolute"
                maxW="70%"
                objectFit="contain"
                opacity={0.95}
                pointerEvents="none"
                userSelect="none"
            />
        </Flex>
    );
};

export default LoginHero;
